'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_UsersView$$anon$42(outer) {
  this.bPl = null;
  this.bPj = null;
  this.bPk = false;
  this.bPh = null;
  this.bPi = false;
  this.bPm = false;
  this.bPn = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bPl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_UsersView$$anon$42 as $c_Lpresto_UsersView$$anon$42 };
$p = $c_Lpresto_UsersView$$anon$42.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_UsersView$$anon$42;
/** @constructor */
function $h_Lpresto_UsersView$$anon$42() {
}
export { $h_Lpresto_UsersView$$anon$42 as $h_Lpresto_UsersView$$anon$42 };
$h_Lpresto_UsersView$$anon$42.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bPl;
});
$p.t = (function() {
  if ((!this.bPk)) {
    this.bPj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("active", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("update", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bPk = true;
  }
  return this.bPj;
});
$p.ag = (function() {
  if ((!this.bPi)) {
    this.bPh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().ae9()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().ph(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bPi = true;
  }
  return this.bPh;
});
$p.v = (function() {
  if ((!this.bPn)) {
    this.bPm = false;
    this.bPn = true;
  }
  return this.bPm;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_UsersView$$anon$42 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_UsersView$$anon$42, "presto.UsersView$$anon$42", ({
  V1: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_UsersView$$anon$42 as $d_Lpresto_UsersView$$anon$42 };
//# sourceMappingURL=presto.-Users-View$$anon$42.js.map
